const wagonrSliders = [
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Grill.png',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Grill.png',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Dualtone.png',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Dualtone.png',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Floating_Roof.png',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Floating_Roof.png',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Alloy_Wheels.png',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Alloy_Wheels.png',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Spacious_boot.png',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Spacious_boot.png',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Spacious_Cabin.png',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/Spacious_Cabin.png',
  },
];

const wagonrColors = [
  {
    id: 1,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/PREMIUM-GALLANT-RED_Dual.webp',
  },
  {
    id: 2,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/NUTMEG-BROWN.webp',
  },
  {
    id: 3,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/SILKY-SILVER.webp',
  },
  {
    id: 4,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/METALLIC-MAGMA-GREY.webp',
  },
  {
    id: 5,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/POOLSIDE-BLUE.webp',
  },
  {
    id: 6,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/PREMIUM-GALLANT_RED.webp',
  },
  {
    id: 7,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/METALLIC-MAGMA-GREY_Dual.webp',
  },
  {
    id: 8,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/data/wagonr/colors/SOLID-WHITE.webp',
  },
  {
    id: 9,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/wagon-r/wagonr-black.webp',
  },
];

const wagonrVariants = [
  {
    id: 1,
    title: 'LXI 1L',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '24.35 ',
    price: '₹ 5,64,500 Lakh',
  },
  {
    id: 2,
    title: 'vxi 1l',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '24.35 ',
    price: '₹ 6,09,500 Lakh',
  },
  {
    id: 3,
    title: 'vxi ags 1l',
    transmission: 'AUTOMATIC',
    engine: '998 cc',
    mileage: '23.56 ',
    price: '₹ 6,59,500 Lakh',
  },
  {
    id: 4,
    title: 'zxi 1.2l',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '34.05 ',
    price: '₹ 6,38,000 Lakh',
  },
  {
    id: 5,
    title: 'zxi ags 1.2l',
    transmission: 'AUTOMATIC',
    engine: '998 cc',
    mileage: '25.19 ',
    price: '₹ 6,88,000 Lakh',
  },

  {
    id: 6,
    title: 'zxi+ (D)',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '23.56 ',
    price: '₹ 6,97,500 Lakh',
  },
  {
    id: 7,
    title: 'zxi+',
    transmission: 'MANUAL',
    engine: '1197 cc',
    mileage: '23.56 ',
    price: '₹ 6,85,500 Lakh',
  },
  {
    id: 8,
    title: 'zxi+ ags(D)',
    transmission: 'AUTOMATIC',
    engine: '998 cc',
    mileage: '34.05 ',
    price: '₹ 7,47,500 Lakh',
  },
  {
    id: 9,
    title: 'zxi+ ags',
    transmission: 'AUTOMATIC',
    engine: '998 cc',
    mileage: '24.43 ',
    price: '₹ 7,35,500 Lakh',
  },
  {
    id: 10,
    title: 'lxi cng 1l',
    transmission: 'MANUAL',
    engine: '1197 cc',
    mileage: '24.43 ',
    price: '₹ 6,54,500 Lakh',
  },
  {
    id: 11,
    title: 'vxi cng 1l',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '32.5 ',
    price: '₹ 6,99,500 Lakh',
  },
  {
    id: 12,
    title: 'tour h3 1l',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '32.5 ',
    price: '₹ 5,61,500 Lakh',
  },
  {
    id: 13,
    title: 'tour h3 cng 1l',
    transmission: 'MANUAL',
    engine: '998 cc',
    mileage: '32.5 ',
    price: '₹ 6,51,500 Lakh',
  },
  {
    id: 14,
    title: '',
    transmission: '',
    engine: '',
    mileage: '',
    price: '',
  },
];

const wagonrMileage = [
  {
    id: 1,

    transmission: 'MANUAL',
    engine: '1.0L Petrol ',
    mileage: '24.35 KM/L',
    amileage: '25.19 KM/L',
  },
  {
    id: 2,

    transmission: 'MANUAL',
    engine: '1.2L petrol ',
    mileage: '23.56 KM/L',
    amileage: '24.43 KM/L',
  },
  {
    id: 3,

    transmission: 'AUTOMATIC',
    engine: '1.0L S-CNG ',
    mileage: '34.05 KM/KG ',
    amileage: '',
  },
];


const wagonrData = {
  name: "Wagon R",
  brand: "Maruti Suzuki",
  priceRange: "₹ 5.64 - 7.47 Lakh*",
  specs: [
    { label: "Engine", value: "1197 CC",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/speedometer.png",  },
    { label: "Mileage", value: "34.05 km/kg*",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/gas-station.png", },
    { label: "Power (KW)", value: "66" ,icon : "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/car.png", },
  ],
  iconUrls: [
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/AGS.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/S-CNG_mimimum+black.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/K-SERIES.webp",
  ],
  brochureLink:
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/brochures/Saboo_RKS_WagonR_Brochure.pdf",
  compareLink: "/compare-cars",
  cngLink: "/maruti-wagonr-cng-on-road-price-in-hyderabad",
};

export { wagonrSliders, wagonrColors, wagonrVariants, wagonrMileage,wagonrData };
